<template>
  <el-table-column
    prop="valid_from"
    sortable="custom"
    label="Érvényesség kezdete"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      {{ scope.row.valid_from | date }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'valid_from',
};
</script>
